import React from 'react'
import styles from './LPHeader.module.scss'
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

interface HeaderLink {
  href: string
  title: string
}

const hederLinks: HeaderLink[] = [
  {
    href: '#top',
    title: 'トップ',
  },
  {
    href: '#features',
    title: '特徴',
  },
  {
    href: '#process',
    title: 'プロセス',
  },
  {
    href: '#performance',
    title: '実績',
  },
  {
    href: '#projectflow',
    title: 'プロジェクト開始までの流れ',
  },
  {
    href: '#FAQ',
    title: 'よくある質問',
  },
]

const hederList = hederLinks.map(({ href, title }) => (
  <li key={title} className={`${styles.li} ${styles.SP_none}`}>
    <a href={href}>{title}</a>
  </li>
))

const LPHeader: React.FC = () => {
  const router = useRouter()
  const header = useRef<HTMLDivElement>()
  const [isPC, setIsPC] = useState(true)
  const [isIE, setIsIE] = useState(false)
  const isCompletedPage = new RegExp('/lp-frontend-contact-completed|/lp-backend-contact-completed').test(
    router.pathname,
  )
  const isFrontend = new RegExp('frontend-dev').test(router.pathname)
  const isBackend = new RegExp('backend-dev').test(router.pathname)

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      setIsIE(true)
    }

    // レイアウトの関係でフロントエンドとバックエンドLPはHubSpotフォームが2箇所必要
    // しかし同じフォームが複数ある場合、フォームの動作は先勝ちとなり2個目以降のフォームは送信ボタンが動作しなくなる
    // そのため、スマホの場合は一個目にくる当コンポーネントのHubSpotフォームは削除
    // isPCがfalse=>削除、true=>表示
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        setIsPC(false)
      } else {
        setIsPC(true)
      }
    })

    gsap.to(header.current, {
      y: -15,
      scale: 0.9,
      ease: 'none',
      scrollTrigger: {
        trigger: '#frontendLP',
        start: 'top+=10px top',
        toggleActions: 'play not reverse reverse',
      },
    })
  }, [isPC])

  if (isCompletedPage) {
    return (
      <header>
        <section className={styles.section}>
          <div ref={header} className={styles.header}>
            <ul className={styles.ul} id="ul">
              {hederList}
            </ul>
          </div>
        </section>
      </header>
    )
  }
  if (!isCompletedPage) {
    return (
      <header>
        {isIE ? (
          <script src="https://js.hsforms.net/forms/v2-legacy.js"></script>
        ) : (
          <script src="https://js.hsforms.net/forms/v2.js"></script>
        )}
        <section className={styles.section}>
          <div ref={header} className={styles.header}>
            <ul className={styles.ul} id="ul">
              {hederList}
            </ul>
          </div>
          <ContactForm isPC={isPC} isFrontend={isFrontend} isBackend={isBackend} />
        </section>
        <a href="#contact" className={styles.contact_area_sp}>
          お問い合わせ
        </a>
      </header>
    )
  }
}

// hooksのなかで条件分岐による表示の出しわけがある場合エラーが起きる
// 別コンポーネントに分けて表示させることで解消
interface ContactFormItem {
  isPC: boolean
  isFrontend: boolean
  isBackend: boolean
}
const ContactForm: React.FC<ContactFormItem> = ({ isPC, isFrontend, isBackend }) => {
  if (isPC && isFrontend) {
    useHubSpotGenerate('na1', '9395227', '7627e517-d385-49b8-9b6a-4a86df93c5a3', '#hbspt')
  }
  if (isPC && isBackend) {
    useHubSpotGenerate('na1', '9395227', '491ada07-e8a0-42aa-a802-3dd70375440c', '#hbspt')
  }
  return (
    <>
      {isPC && (
        <div className={styles.contact_area}>
          <p className={styles.title}>お問い合わせ</p>
          <div className={isBackend ? 'backend_hubSpot frontend_hubSpot' : 'frontend_hubSpot'} id="hbspt"></div>
        </div>
      )}
    </>
  )
}

export default LPHeader
